export default __webpack_public_path__ + "e63d9e31a7f421ca756bdd06300e4923.png";